import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.0001 2.1001C6.53247 2.1001 2.1001 6.53248 2.1001 12.0001C2.1001 17.4677 6.53247 21.9001 12.0001 21.9001C17.4677 21.9001 21.9001 17.4677 21.9001 12.0001C21.9001 6.53248 17.4677 2.1001 12.0001 2.1001ZM12.0001 7.00012C11.4478 7.00012 11.0001 7.44784 11.0001 8.00012C11.0001 8.55241 11.4478 9.00012 12.0001 9.00012C12.5524 9.00012 13.0001 8.55241 13.0001 8.00012C13.0001 7.44784 12.5524 7.00012 12.0001 7.00012ZM11.1001 17.0001V10.5001H12.9001V17.0001H11.1001Z",
		fill: "currentColor"
	})
});
export default SvgIcInfo;
